import { GetJobTotalPriceAggregationsResponse } from '@taxfyle/api-internal/internal/job_stats_pb'
import { decimalToNumber } from '../../../../utils/grpc-util'
import { JobsTotalPricing } from './JobsTotalPricing'

/**
 * Maps a `GetJobsTotalPricingResponse` to a `JobsTotalPricing`.
 * @param payload
 * @returns `JobsTotalPricing` dto.
 */
export function mapGetJobTotalPriceAggregateToDTO(
  payload: GetJobTotalPriceAggregationsResponse.AsObject
): JobsTotalPricing {
  return {
    submittedJobsTotalPrice: payload.submittedjobstotalprice
      ? decimalToNumber(payload.submittedjobstotalprice)
      : 0,
    closedJobsTotalPrice: payload.closedjobstotalprice
      ? decimalToNumber(payload.closedjobstotalprice)
      : 0,
  }
}
